import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do ophthalmologists drive LASIK volume?",
    "a": "LASIK-specific pages, surgeon-credibility content, and Google ads tuned to research-stage and ready-to-book searches. Big chains polish; surgeon-led practices win on credibility and outcomes."
  },
  {
    "q": "Is Google Ads worth it for ophthalmology?",
    "a": "Yes for LASIK and premium IOL — case values justify CPCs. For medical eye care, SEO and GBP drive more value."
  },
  {
    "q": "How do we beat LASIK chains in search?",
    "a": "Surgeon-led pages, real outcome data, and review velocity. Chains operate at scale; surgeons operate at depth. The right content makes that depth visible."
  },
  {
    "q": "Do you handle multi-specialty ophthalmology?",
    "a": "Yes — glaucoma, retina, pediatric, and oculoplastics each get their own pages and pipelines."
  },
  {
    "q": "Are HIPAA considerations handled?",
    "a": "Yes — forms, analytics, and ad tracking are configured to respect PHI from day one."
  }
];

export const Route = createFileRoute("/ophthalmologist-marketing-colorado")({
  head: () =>
    industryMarketingHead("Ophthalmologist", "ophthalmology practice", "ophthalmologist-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Ophthalmologist"}
      industryLower={"ophthalmology practice"}
      slug={"ophthalmologist-marketing-colorado"}
      subheadline={"We help Colorado ophthalmology practices drive LASIK, cataract, and premium-lens consults — beyond optometrist referrals alone."}
      painPoints={["LASIK and premium IOL volume is below capacity","Optometrist referrals fluctuate and you can't predict the OR calendar","Big LASIK chains (LasikPlus, TLC) dominate your local search"]}
      serviceDescriptions={{
        seo: "Rank for LASIK, cataract, premium IOL, glaucoma, retina, and every eye care service in every Colorado market.",
        googleMaps: "Own 'eye doctor near me' and 'LASIK near me' in the Map Pack with surgeon-credibility signals.",
        webDesign: "Procedure-specific pages — LASIK, cataract, premium lenses — with surgeon bios and consult-booking funnels.",
        ppc: "Profitable Google Ads for LASIK and premium-IOL cataract with strong ROAS tracking.",
        geoAi: "Get cited when patients ask ChatGPT 'best LASIK surgeon in Denver' or 'cataract surgeon near me'.",
        socialMedia: "Surgeon-led education content that builds authority and converts the high-ticket consult.",
      }}
      testimonial={{"quote":"LASIK consults tripled and premium IOL conversion is up. We finally have a pipeline that doesn't depend on optometrist referrals.","role":"Refractive Surgeon & Practice Owner","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Ophthalmology marketing in Colorado Springs","description":"LASIK and cataract marketing across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Ophthalmology marketing in Denver","description":"Compete with LASIK chains in Denver's competitive market."},{"to":"/boulder-digital-marketing","label":"Ophthalmology marketing in Boulder","description":"Premium refractive and cataract care for Boulder's health-conscious patients."}]}
    />
  ),
});
